import Vue from "vue";
// eslint-disable-next-line import/no-extraneous-dependencies
import "normalize.css/normalize.css";
// eslint-disable-next-line import/no-extraneous-dependencies
import ElementUI from "element-ui";
// eslint-disable-next-line import/no-extraneous-dependencies
import "element-ui/lib/theme-chalk/index.css";
import 'xgplayer/dist/index.min.css';
import App from "./App.vue";
import router from "./router/index.js";
import Vant from "./utils/vant";
import global from "./utils/global";
import loginBox from "./utils/login-box";
import validForm from "@/utils/validForm.js";
import uploadPicture from "@/components/uploadPicture";

Vue.component("uploadPicture", uploadPicture);

Vue.use(validForm);
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(global);
Vue.use(loginBox)


Vue.config.productionTip = false;


Vue.config.errorHandler = function errorHandler(err, vm, info) {
  console.error("Global Error:", err, vm, info);
};
new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
